import { GameConstants } from "../../GameConstants";

import { GameVars } from "../../GameVars";

import { HelpLayer } from "./HelpLayer";

import { AudioManager } from "../../AudioManager";

export class InstructionsContainer extends Phaser.Group {

    private instructionsImage: Phaser.Image;
    
    constructor(game: Phaser.Game) {

        super(game, null, "instructions-container");

        this.y = GameConstants.GAME_HEIGHT - 20;
        this.scale.y = GameVars.scaleY;

        const darkLayer: Phaser.Sprite = this.create(0, -270, this.game.cache.getBitmapData(GameConstants.DARK_BLUE_SQUARE));
        darkLayer.scale.set(GameConstants.GAME_WIDTH / GameConstants.BITMAP_SIZE, 340 / GameConstants.BITMAP_SIZE);
        darkLayer.alpha = .75;

        const leftArrowButton = new Phaser.Button(this.game, GameConstants.GAME_WIDTH / 2 - 310, -310, "texture_atlas_1", this.onClickArrowButton, this);
        leftArrowButton.setFrames("button_arrow_on.png", "button_arrow_off.png", "button_arrow_on.png");
        leftArrowButton.angle = 180;
        leftArrowButton.name = GameConstants.LEFT;
        leftArrowButton.anchor.set(.5);
        leftArrowButton.forceOut = true;
        this.add(leftArrowButton);

        const rightArrowButton = new Phaser.Button(this.game, GameConstants.GAME_WIDTH / 2 + 310, -310, "texture_atlas_1", this.onClickArrowButton, this);
        rightArrowButton.setFrames("button_arrow_on.png", "button_arrow_off.png", "button_arrow_on.png");
        rightArrowButton.name = GameConstants.RIGHT;
        rightArrowButton.anchor.set(.5);
        rightArrowButton.forceOut = true;
        this.add(rightArrowButton);

        const instructionsTextureName: string = "rules_" + HelpLayer.currentPage.toString() + ".png";

        this.instructionsImage = new Phaser.Image(this.game, GameConstants.GAME_WIDTH / 2, 0, "texture_atlas_2", instructionsTextureName);
        this.instructionsImage.anchor.set(.5, 1);
        this.instructionsImage.scale.set(1.125);
        this.add(this.instructionsImage);
    }

    private onClickArrowButton(b: Phaser.Button): void {

        if (b.name === GameConstants.RIGHT) {
            HelpLayer.currentPage = HelpLayer.currentPage < 13 ? HelpLayer.currentPage + 1 : 1;
        } else {
            HelpLayer.currentPage = HelpLayer.currentPage > 1 ? HelpLayer.currentPage - 1 : 13;
        }

        this.instructionsImage.frameName = "rules_" + HelpLayer.currentPage.toString() + ".png";

        HelpLayer.currentInstance.pageChanged();

        AudioManager.playSound("click"); 
    }
}
